export const pastMedicalIssuesOptions = [
  { label: "Hypertension", value: "hypertension" },
  { label: "Diabetes", value: "diabetes" },
  { label: "Heart Disease", value: "heart_disease" },
  { label: "Asthma", value: "asthma" },
  { label: "Depression", value: "depression" },
  { label: "Anxiety", value: "anxiety" },
  { label: "Arthritis", value: "arthritis" },
  { label: "Cancer", value: "cancer" },
  { label: "Stroke", value: "stroke" },
  { label: "Kidney Disease", value: "kidney_disease" },
];
